import "./styles.css";
import TotalContainer from './TotalContainer'
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import RedditPosts from "./RedditPosts";
import About from "./pages/About";
import LeagueLineups from "./pages/LeagueLineups";
import Tools from "./pages/Tools";
import TradeValues from "./pages/TradeValues";
import Trades from "./pages/Trades";
import { TRADES_ENABLED } from "./featureFlags";
// import Navbar from "./Navbar";

export default function App() {
  return (
    <div className="App">
      <Router>
        {/* <Navbar/> */}
        <Routes>
          <Route path="/" element={
            <TotalContainer />}
          />
          <Route title="Trade Value Chart" path="/about" element={<About />} />
          <Route path="/leagueLineups" element={<LeagueLineups />} />
          <Route path="/espnLineups" element={<LeagueLineups />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tradeValues" element={<TradeValues />} />
          <Route path="/trades" element={TRADES_ENABLED ? <Trades /> : <Navigate to="/tools" replace />} />
          <Route  path="/redditPosts/:week" element={<RedditPosts />}>
          </Route>

        </Routes>
      </Router>
    </div>
  );
}
